import { ActionIcon, Group, Skeleton, Stack } from '@mantine/core';
import { FC, useContext, useMemo } from 'react';
import { IconArrowLeft } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';
import { EventContext } from '../../Service/Context/EventContext';
import { EventDate } from '../../Types/Event';
import { ThemeText } from '../../Atoms/ThemeText';
import { isDefined } from '../../Service/ValidationS';

const EventBreadCrumbs: FC = () => {
  const navigate = useNavigate();
  const { event, loadingEvent, dates } = useContext<any>(EventContext);
  const regularDates = dates.filter((d: EventDate) => d.type === 'REGULAR_DATE');
  const withoutDates = regularDates.length === 0;
  const primaryDate = dates.find((ed: EventDate) => ed.useAsPrimary);
  const eventNameProvided = useMemo(() => event && isDefined(event.name), [event]);

  if (loadingEvent) {
    return <Skeleton p="sm" height={40} />;
  }

  return (
    <>
      {withoutDates && <ThemeText size="xl">Bisher kein Termin</ThemeText>}
      {!withoutDates && (
        <Group spacing="xs">
          <ActionIcon ml={5} mr="xs" onClick={() => navigate('/')}>
            <IconArrowLeft />
          </ActionIcon>
          <Stack spacing={0}>
            {eventNameProvided && <ThemeText>{event.name}</ThemeText>}
            {!eventNameProvided && <ThemeText>Event am</ThemeText>}
            <ThemeText size="xl" weight="bolder">{`${
              primaryDate ? primaryDate.weekday : dates[0].weekday
            }, ${new Intl.DateTimeFormat('de').format(
              new Date(primaryDate ? primaryDate.date : dates[0].date),
            )}`}</ThemeText>
          </Stack>
        </Group>
      )}
    </>
  );
};

export default EventBreadCrumbs;
